export const MOBILE_MENU_WIDTH = 220
